$(function(){
	$('.hamburger').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('open');
		if($(this).hasClass('open'))
			$('.menu-dropdown').addClass('menu-dropdown--down');
		else
			$('.menu-dropdown').removeClass('menu-dropdown--down');
	});
});